<template>
  <div class="row">
    <div class="col-12">
      <code v-if="debug">
        {{ data }}
        <hr />
        {{ model }}
      </code>

      <div>
        <b-form-group label="Destination/Country" :disabled="false">
          <b-form-input
            :state="destinationValid"
            v-model="model.DestinationCountry"
            :maxlength="3"
            class="col-1 uc"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Document Type" :disabled="false">
          <v-select
            v-model="model.DocumentType"
            :options="['P', 'I', '*']"
            label="Document Type"
          >
          </v-select>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Nationality" :disabled="false">
          <b-form-input
            v-model="model.Nationality"
            :maxlength="3"
            class="col-1 uc"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Expiry Date Check Days" :disabled="false">
          <b-form-input
            type="number"
            v-model="model.ExpiryDateCheckDays"
            :maxlength="3"
            min="-1"
            class="col-1 uc"
          ></b-form-input>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Pax Warning" :disabled="false">
          <div class="toggleWrapper">
            <input
              id="PaxWarning"
              v-model="boolsSwitches.PaxWarning"
              class="dn"
              type="checkbox"
            />
            <label class="toggle" for="PaxWarning"
              ><span class="toggle__handler"></span
            ></label>
          </div>
        </b-form-group>
      </div>

      <div>
        <b-form-group label="Description" :disabled="false">
          <b-form-textarea
            v-model="model.Description"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </div>
    </div>
    <hr />
    <div class="col-12 bt-1">
      <b-button variant="success" class="mr-1" @click="save">Save</b-button>
      <b-button variant="success" @click="saveAndClose"
        >Save &amp; Close</b-button
      >
      <b-button variant="secondary" class="ml-1" @click="cancel"
        >Cancel</b-button
      >
    </div>
  </div>
</template>

<script>
import NotificationMixin from '@mixins/notificationMixin.js'
import CancelMixin from '@mixins/cancel.js'
export default {
  mixins: [NotificationMixin, CancelMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      debug: false,
      enabledState: null,
      boolsSwitches: {
        PaxWarning: false,
      },
      model: {
        ApisRouteId: null,
        DestinationCountry: null,
        DocumentType: null,
        Nationality: null,
        ExpiryDateCheckDays: null,
        PaxWarning: null,
        Description: null,
      },
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(data) {
        if (data) this.mapData(data)
      },
    },
    enabledState(enabled) {
      this.model.Enabled = enabled ? 'T' : 'F'
    },
    boolsSwitches: {
      deep: true,
      handler(bools) {
        // The server model uses T/F rather than bools!
        this.model.PaxWarning = bools.PaxWarning ? 'T' : 'F'
      
      },
    },
  },
  computed: {
    destinationValid() {
      if(this.model.DestinationCountry === '*') {return true}
      return (
        this.model.DestinationCountry &&
        this.model.DestinationCountry.length > 1 &&
        this.model.DestinationCountry.length <= 3
      )
    },
  },
  methods: {
    mapData(dataIn) {
      //   Take the server data and apply it to our model
      this.model.ApisRouteId = dataIn.ApisRouteId
      this.model.DestinationCountry = dataIn.DestinationCountry
      this.model.DocumentType = dataIn.DocumentType
      this.model.Nationality = dataIn.Nationality
      this.model.ExpiryDateCheckDays = dataIn.ExpiryDateCheckDays
      this.model.PaxWarning = dataIn.PaxWarning
      this.model.Description = dataIn.Description

      this.boolsSwitches.PaxWarning = dataIn.PaxWarning === 'T'
    },
    async save() {
      if (this.saveDisabled) {
        return
      }
      let id, type
      if (this.data) {
        id = this.data[this.contentType.idKey]
        type = 'patch'
      } else {
        id = 0
        type = 'post'
      }
      try {
        this.model.DestinationCountry = this.model.DestinationCountry.toUpperCase();
        
        this.model.Nationality = this.model.Nationality.toUpperCase();
        await this.$store.dispatch(`${this.contentType.name}/${type}`, {
          id: id,
          body: this.model,
        })
        this.showNotification('Saved successfully', 'success')
      } catch (error) {
        
        this.showNotification(error, 'error')

        throw new Error(error)
      }
    },
    async saveAndClose() {
      if (this.saveDisabled) {
        return
      }
      try {
        await this.save()
      } catch (error) {
        window.console.log(error)
        return
      }
      this.$router.push(`/${this.contentType.name}/list`)
    },
  },
}
</script>
